import * as React from "react";
import Landing from "./Landing";
import * as CONSTANTS from "../../utilities/Constants";
import logActions from "../../flux/actions/LogActions";
import logListStore from "../../flux/stores/logs/ListStore";
import { ILogViewData } from "../../models/logs/LogViewData";
import moment from "moment";
import triggerNotifications from "../../utilities/TriggerNotifications";
import getLicenseDetailsStore from "../../flux/stores/license/GetLicenseDetailsStore";
import licenseActions from "../../flux/actions/LicenseActions";

interface ILogLandingState {
  reducedArray: any;
  logsData: ILogViewData[];
  selectedDateRange: any[];
  selectFromDate: string | null;
  selectToDate: string | null;
  selectedModule: any[];
  searchInput: string;
  licenseDetails: any;
  isLicenseApplicable: boolean;
}

export default class Logs extends React.Component<{}, ILogLandingState> {
  private _mount = false;
  private logsData: ILogViewData[] = [];
  private _datetimeFormat = "YYYY-MM-DD HH:mm:ss";
  private _pageToScroll = 0;
  private _logsData: any = "";
  private moduleDropdownList = [
    {
      label: "All",
      value: "All"
    },
    {
      label: "Sample",
      value: "Sample"
    },
    {
      label: "Device",
      value: "Device"
    },
    {
      label: "Notification",
      value: "Notification"
    },
    {
      label: "Authentication",
      value: "Authentication"
    },
    {
      label: "Filewatcher",
      value: "Filewatcher"
    },
    {
      label: "Logviewer",
      value: "Logviewer"
    }
    
  ]

  constructor(props: { location: any }) {
    super(props);

    this.state = {
      reducedArray: [],
      logsData: [],
      selectedDateRange: [{
        value: CONSTANTS.DATE_RANGES[0].value,
        label: CONSTANTS.DATE_RANGES[0].label
      }],
      selectFromDate: moment().subtract(1, 'd').format(this._datetimeFormat),
      selectToDate: moment().format(this._datetimeFormat),
      selectedModule: [{
        value: "All",
        label: "All"
      }],
      searchInput: "",
      licenseDetails: [],
      isLicenseApplicable: false,
    };
  }

  componentDidMount() {
    this._mount = true;
    logListStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
      if (this._mount) {
        this.logsData = state?.logDataList?.result;
      }
    });

    logActions
      .getAll(
        moment.utc(this.state.selectFromDate).format("YYYY-MM-DDTHH:mm:ss"),
        moment.utc(this.state.selectToDate).format("YYYY-MM-DDTHH:mm:ss"),
        false,
        1,
        1000,
        CONSTANTS.SORT_TIMESTAMP,
        CONSTANTS.SORT_ORDER,
        ""
      )
      .then(() => {
        this.setState({ logsData: this.logsData })
        this._logsData = JSON.stringify(this.logsData)
        this.setState({ reducedArray: this.reduceArrayHandler(this.logsData) })
      });

      getLicenseDetailsStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
        this.setState({ licenseDetails: state.licenseData.data });
      });
      this.getLicenseData();
  }

  private getLicenseData = () => {
    licenseActions
      .getLicenseDetails()
      .then(() => {
        const response: any = this.state.licenseDetails?.some((node:any) => !node.isLicenseApplicable);
        if (response) {
        } else {
          this.moduleDropdownList.push({
            label: "Licensing",
            value: "Licensing"
          });
        }
      })
  }

  reduceArrayHandler = (data: any[]) => {
    let reducedArray;
    if (data.length !== 0) {
      reducedArray = data.reduce((x: any, y: any) => {
        const { level } = y;
        x[level] = x[level] ?? [];
        x[level].push(y)
        return x;
      }, {})
    } else{
      reducedArray = [];
    }
    return reducedArray
  }

  dateRangeHandler = (val: any) => {
    this.setState(
      {
        selectedDateRange: val,
      },
      this.postAll
    );
    let fromDate: any = "",
      toDate: any = "";
    let selectedDate = val[0]?.value;
    toDate = moment().format(this._datetimeFormat);
    switch (selectedDate) {
      case 1:
        fromDate = moment().subtract(1, "d").format(this._datetimeFormat);
        break;
      case 2:
        fromDate = moment().subtract(7, "d").format(this._datetimeFormat);
        break;
      case 3:
        fromDate = moment().subtract(30, "d").format(this._datetimeFormat);
        break;
      case 4:
        fromDate = this.state.selectFromDate
          ? this.state.selectFromDate
          : moment().subtract(1, "d").format(this._datetimeFormat);
        toDate = this.state.selectToDate
          ? this.state.selectToDate
          : moment().format(this._datetimeFormat);
        break;
      default:
        fromDate = moment().subtract(1, "d").format(this._datetimeFormat);
        break;
    }
    if (moment(fromDate) >= moment(toDate)) {
      triggerNotifications.errors([CONSTANTS.FROM_GRATER_TO]).then();
    } else {
      this.setState({
        selectFromDate: fromDate,
        selectToDate: toDate,
      });
    }
  };

  public postAll = () => {
    const pageSize = (this._pageToScroll + 1) * 1000;
    let strConcat = "";
    strConcat = `${this.state?.searchInput}&`+`${"module"}:${this.state.selectedModule[0]?.value}&`
    const payload = {
      from: moment.utc(this.state.selectFromDate).format("YYYY-MM-DDTHH:mm:ss"),
      to: moment.utc(this.state.selectToDate).format("YYYY-MM-DDTHH:mm:ss"),
      isAll: false,
      page: 1,
      pageSize: pageSize,
      sort: CONSTANTS.SORT_TIMESTAMP,
      order: CONSTANTS.SORT_ORDER,
      filter: strConcat
    }
    logActions
      .getAll(
        payload.from,
        payload.to,
        payload.isAll,
        payload.page,
        payload.pageSize,
        payload.sort,
        payload.order,
        payload.filter
      )
      .then(() => {
        this.setState({ logsData: this.logsData, reducedArray: this.reduceArrayHandler(this.logsData) })
      })
  }

  private searchInputChangeHandler = (val: any) => {
    this.setState({
      searchInput: val
    }, () => {
      this.postAll()
    })
  }

  private setTrendCustomFromDate = (val: any) => {
    if (moment(val).format(this._datetimeFormat) >= this.state.selectToDate) {
      triggerNotifications.errors([CONSTANTS.FROM_GRATER_TO]).then();
    }
    this.setState(
      { selectFromDate: moment(val).format(this._datetimeFormat) },
      this.postAll
    );
  };
  private setTrendCustomToDate = (val: any) => {
    if (this.state.selectFromDate >= moment(val).format(this._datetimeFormat)) {
      triggerNotifications.errors([CONSTANTS.FROM_GRATER_TO]).then();
    }
    this.setState(
      { selectToDate: moment(val).format(this._datetimeFormat) },
      this.postAll
    );
  };

  public moduleChangeHandler = (value: any) => {
    this.setState({
      selectedModule: value
    }, ()=> {
      this.postAll();
    })
    
  }

  public render() {
    return (
      <div className="layout-margin">
        <Landing
          logsData={this.state?.logsData}
          reducedArray={this.state.reducedArray}
          dateRangeHandler={this.dateRangeHandler}
          selectedDateRange={this.state.selectedDateRange}
          selectFromDate={this.state.selectFromDate}
          selectToDate={this.state.selectToDate}
          setTrendCustomFromDate={this.setTrendCustomFromDate}
          setTrendCustomToDate={this.setTrendCustomToDate}
          moduleDropdownList={this.moduleDropdownList}
          selectedModule={this.state.selectedModule}
          moduleChangeHandler={this.moduleChangeHandler}
          searchInputChangeHandler={this.searchInputChangeHandler}
          searchInput={this.state.searchInput}
        ></Landing>
      </div>
    );
  }
}
